<template>
  <el-container  style="display: block;">

    <el-row  class="tui-el"  style="margin-top: 20px;margin-left: 3%;">
      
        <el-row :span="2" style="margin-top: 30px;">
            <el-input v-model="seachName" style="width: 150px;" placeholder="请输入名称"></el-input>

            <el-button type="primary" style="background-color: #409eff;" @click="seach()" round>搜索</el-button>
        </el-row>

        <el-row  class="elementsz" style="margin-top: 30px;">
          <template>
            <el-table
          	:data="list"
            height="1000"
          	border
          	style="width: 95%;margin-left: 0;height: 800px;text-align: center;">
            <el-table-column

              width="300"
              label="名称"
               >
               <template slot-scope="scope">                   
				   <div @click="changeName(scope.row.id,scope.row.name,1)">{{scope.row.name}}</div>
               </template>
            </el-table-column>
            
            <el-table-column

              width="600"
              label="vr"
               >
               <template slot-scope="scope">
                   <div @click="changeName(scope.row.id,scope.row.vr,2)">{{scope.row.vr}}</div>
               </template>
            </el-table-column>
            <el-table-column
            
              width="600"
              label="截取坐标"
               >
               <template slot-scope="scope">
                   <div @click="changeName(scope.row.id,scope.row.zuobiao,3)">{{scope.row.zuobiao}}</div>
               </template>
            </el-table-column>
            

           
            </el-table>
          </template>
          <div class="page">
          	<el-pagination
          	  @size-change="loadList()"
          	  @current-change="loadList()"
          	  :current-page.sync="page"
          	  :page-size="15"
          	  background
          	  layout="total,prev, pager, next, jumper"
          	  :total="count">
          	</el-pagination>
          </div>
        </el-row>






    </el-row>
    
    <el-dialog
      title="修改"
      :visible.sync="disDialogVisible"
      width="30%"
      center>
      <input type="text" class="searchT" v-model="names"/>
      <span slot="footer" class="dialog-footer">
    	<el-button @click="disDialogVisible = false">取 消</el-button>
    	<el-button type="primary" @click="doChangeName()">确 定</el-button>
      </span>
    </el-dialog>
  </el-container>
</template>

<script>
  export default {
    data() {
       return {
         page:1,
         count:0,
         list:[],
         name:'',
         url:'',
         names:'',
         disDialogVisible:false,
         changeId:0,
         t:0,
         addImg:'',
         addImgs:'',
         imageId:0,
         seachName:'',
         imgId:0,
         cid:0,
         did:0,
         disDel:false,
         t:0,
		 j_id:this.$route.query.id,



      }
    },
  directives: {
    },
    created() {

      this.loadList();

    },

  methods:{
    
    changeName(id,name,t){
      this.cid = id
      this.names = name
      this.t = t
      this.disDialogVisible = true
    },
    doChangeName(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });


      axiosInstance({
      	method:'post',
      	params:{
      	  id:this.cid,
          name:this.names,
          t:this.t

      	},
      	url:'http://y31p.yoooooo.com/index.php/index/data/byxiaoqu1ChangeName'
      })
      .then(res=>{
      	if(res.data.code == 200){
           this.cid = 0
           this.t = 0
           this.disDialogVisible = false
           this.$message({
           	type: 'success',
           	message: '操作成功'
           });
           this.loadList();
      	}else{

      	}

      })
      .catch(err=>{

      });
    },
     
    seach(){
      this.loadList();
    },
   

    loadList(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'get',
      	params:{
          name:this.seachName,
          p:this.page,
		  j_id:this.j_id,	
      	},
      	url:'http://y31p.yoooooo.com/index.php/index/data/byxiaoqu1List'
      })
      .then(res=>{

        this.list = res.data.list;
        // this.list.forEach(function(item, index) {
        
        //       item['lables'] = item['lable'].split(',');
        // })
        this.count = res.data.count;


      })
      .catch(err=>{

      });
    },
    msg(msg,type){
    	this.$message({
    	  message: msg,
    	  type: type
    	});
    },

  }


  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/main/byxiaoqu1.vue